import { useState } from "react";

const images = [
  "/images/boats.jpg", 
  "/images/camping.jpg",
  "/images/house.jpg",
];

function ImagesShow() {
  const [index, setIndex] = useState(0);

  const prev = () => {
    setIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const next = () => {
    setIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
    console.log("Image:", images[index]);
  };

  return (
    <div style={{ maxWidth: 600, margin: "0 auto", textAlign: "center" }}>
      <div style={{ position: "relative" }}>
        <img
          src={images[index]}
          alt={`Bild ${index + 1}`}
          style={{ width: "100%", borderRadius: 8 }}
        />
      </div>
      <div style={{ marginTop: 12, display: "flex", justifyContent: "center", gap: 8 }}>
        <button onClick={prev}>Zurück</button>
        <span>{index + 1} / {images.length}</span>
        <button onClick={next}>Weiter</button>
      </div>
    </div>
  );
}
export default ImagesShow;